import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
// import Vuelidate from 'vuelidate'
// import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'

import NProgress from 'vue-nprogress'
import Snotify, { SnotifyPosition } from 'vue-snotify'
//import 'vue-snotify/styles/material.css';
import '@/design/snotify-style.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from "vue-select";

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'
// import Swal from "sweetalert2";

import VueCookies from 'vue-cookies-reactive'
import VueCarousel from 'vue-carousel';
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

//import VueAnalytics from 'vue-analytics';


import App from './App.vue'

import { initFirebaseBackend, refreshToken } from './authUtils'
import i18n from './i18n'

const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    icon: false,
    timeout: 2000,
    closeOnClick: true,
    pauseOnHover: true,
    maxOnScreen: 2,
    maxAtPosition: 2,
    preventDuplicates: true,
    //titleMaxLength: 110,
    bodyMaxLength: 1110,
  }
};

Vue.component("v-select", vSelect);
Vue.component("vue-draggable-resizable", VueDraggableResizable)


Vue.use(VueCookies)
Vue.$cookies.config('0','/','',true, 'Lax')
//$cookies.config(expireTimes[,path[, domain[, secure[, sameSite]]])  // default: expireTimes = 1d, path = '/', domain = '', secure = '', sameSite = 'Lax'


initFirebaseBackend();

Vue.use(VueRouter)
Vue.use(vco)


Vue.config.productionTip = false

Vue.use(BootstrapVue)
//Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);

/*Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})*/

Vue.use(VueAxios, axios)
Vue.use(Snotify, options)
Vue.use(VueCarousel);








 
// const nprogress = new NProgress({ parent: '.nprogress-container' })
const nprogress = new NProgress()

const options2 = {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: false, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, options2)


// AXIOS REQUESTS INTERCEPTOR
axios.interceptors.request.use((config) => {
  
    //getting token from cookie
    const token = Vue.$cookies.get('token');

    if (token != null) {
      config.headers.common['Authorization'] = "Bearer " + token;
    }    
    
    if (!config.url.startsWith("/api/auth/refresh")) {
      nprogress.set(0.6)
    }
    
    return config;
}, (error) => {
    nprogress.done();
    return Promise.reject(error);
});

// AXIOS RESPONSES INTERCEPTOR
axios.interceptors.response.use((response) => {
  nprogress.done();
  return response;
}, (error) => {

  nprogress.done();

    if (error == null || error.response == null) {
    return; 
  }

  if (error.response.status == 401) {
    return refreshToken(store).then( () => {

      const token = Vue.$cookies.get('token');
      error.config.headers['Authorization'] = 'Bearer ' + token;
      error.config.baseURL = undefined;
      return axios.request(error.config);
    }, () => {

          console.log('failed to refresh token')

          var currentDomain = window.location.hostname;
          var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain; 

          //delete cookies if refresh fails
          document.cookie = 'token' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'rtoken' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'userr' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'userFullName' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'companyName' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'authUser' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

          document.cookie = 'drafto' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'draftoc' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

          location.reload();
          return;

    });
  }
  
  if (error.response.status == 409) {
      console.log('Une autre session a été ouverte avec le même utilisateur');

      var currentDomain = window.location.hostname;
      var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

       //delete cookies if refresh fails
       document.cookie = 'token' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'rtoken' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'userr' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'userFullName' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'companyName' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'authUser' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

       document.cookie = 'drafto' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'draftoc' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

       location.reload();

      return;    
  }


  if (error.response.status == 500) {
    console.log('500: Une erreur interne du serveur est survenue')
    //Vue.prototype.$snotify.error('Une erreur interne du serveur est survenue');
    return
  }

  if (error.response.status == 404) {
    //Vue.prototype.$snotify.error('Ressource introuvable!');
    console.log('Ressource introuvable!')
    return
  }

  if (error.response.status == 403) {
    //Vue.prototype.$snotify.error('Vous n\'avez pas le droit d\'accéder à la ressource demandée.');
    console.log('403: Vous n\'avez pas le droit d\'accéder à la ressource demandée.')
    return
  }

  if (error.response.status == 401) {
    //Vue.prototype.$snotify.error('Vous n\'avez pas le droit d\'accéder à la ressource demandée.');
    console.log('401: Vous n\'avez pas le droit d\'accéder à la ressource demandée.')
    return
  }

  if (error.response && error.response.data && error.response.status == 400) {
    return Promise.reject(error.response.data);
  } else {
    console.log(error)
    return /* Promise.reject('Une erreur interne du serveur est survenue')*/
  }
  
});



//Vue.use(VueAnalytics, {id: '',router});
Vue.component('apexchart', VueApexCharts)



new Vue({
  router,
  store,

  mounted() {
    this.$store.dispatch('fetchCart');
  },
  i18n,


  render: h => h(App)
}).$mount('#app')
